var _circle, _circle2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyDayBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7,
    fill: "#C4E5EC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6.5,
    stroke: "#1D1E2C"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 0.5,
    x2: 12,
    y2: 3.5,
    stroke: "#1D1E2C",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20.5,
    x2: 12,
    y2: 23.5,
    stroke: "#1D1E2C",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3.70711,
    y1: 4,
    x2: 5.82843,
    y2: 6.12132,
    stroke: "#1D1E2C",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 18.2071,
    y1: 18,
    x2: 20.3284,
    y2: 20.1213,
    stroke: "#1D1E2C",
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 12,
    x2: 3.5,
    y2: 12,
    stroke: "#1D1E2C",
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 20.5,
    y1: 12,
    x2: 23.5,
    y2: 12,
    stroke: "#1D1E2C",
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20.121,
    x2: 6.12132,
    y2: 17.9997,
    stroke: "#1D1E2C",
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 6.12102,
    x2: 20.1213,
    y2: 3.9997,
    stroke: "#1D1E2C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDayBlue);
export default __webpack_public_path__ + "static/media/my-day-blue.db9ac9a8121d0fbb5620d76d6d2a5bc2.svg";
export { ForwardRef as ReactComponent };